module.exports = __webpack_public_path__ + "static/media/chamomile.59082444.jpg";